
var map;

function initMap() {

	//locations
	var location1 = {lat: 46.1648641, lng: -62.6507149};
	var location2 = {lat: 46.3671909, lng: -62.8751492};
	var midpoint = {lat: 46.336082, lng: -62.802725};

	//create map with provided settings and styles
	var map = new google.maps.Map(document.getElementById('map'), {
		center: midpoint,
		zoom: 10,
		draggable: true,
		zoomControl: true,
		scrollwheel: false,
		disableDoubleClickZoom: false,
		mapTypeControl: false,
		styles: [
			{
				"featureType": "administrative",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#444444"
					}
				]
			},
			{
				"featureType": "landscape",
				"elementType": "all",
				"stylers": [
					{
						"color": "#f2f2f2"
					}
				]
			},
			
			{
				"featureType": "road",
				"elementType": "all",
				"stylers": [
					{
						"saturation": -100
					},
					{
						"lightness": 45
					}
				]
			},

			
			{
				"featureType": "water",
				"elementType": "all",
				"stylers": [
					{
						"color": "#00a1d3"
					},
					{
						"visibility": "on"
					}
				]
			}
		]
	});

	//recenter the map when the window resizes
	google.maps.event.addDomListener(window, 'resize', function() {
		google.maps.event.trigger(map, 'resize');
		map.setCenter(midpoint);
		map.setZoom(10);
	});

	//create markers from locations
	var marker1 = new google.maps.Marker({
		position: location1,
		map: map,
		title: 'Montague Facility'
	});

	var marker2 = new google.maps.Marker({
		position: location2,
		map: map,
		title: 'Mount Stewart Facility'
	});

	//Create info windows for markers
	var infowindow1 = new google.maps.InfoWindow({
		content: 
				'<div>' + 
					'<h6>Montague Facility</h6>' +
					'<p>219 Kennedy Street, Montague</p>' +
				'</div>'
	});

	var infowindow2 = new google.maps.InfoWindow({
		content: 
				'<div>' + 
					'<h6>Mount Stewart Facility</h6>' +
					'<p>10693 St Peters Road, Mt. Stewart</p>' +
				'</div>'
	});

	//open
	infowindow1.open(map, marker1);
	infowindow2.open(map, marker2);

	//Marker open/close listeners
	marker1.addListener('click', function() {
		if (infowindow1.anchor == null) {
			infowindow1.open(map, marker1);
		}
		else {
			infowindow1.close();
		}
	});
	marker2.addListener('click', function() {
		if (infowindow2.anchor == null) {
			infowindow2.open(map, marker2);
		}
		else {
			infowindow2.close();
		}
	});
}
